import React from 'react';
import { Link } from 'react-router-dom';
import "./Contact_card.css";

function Contact_card() {
    const contactItems = [
        {
            imgSrc: "/assets/images/contact/location.png",
            title: "UAE Office",
            text: [
                "SFF00014 Compass Building,",
                "Al Shohada Road,",
                "AL Hamra Industrial Zone-FZ,",
                "RAS AL KHAIMAH, United Arab Emirates"
            ]
        },
        {
            imgSrc: "/assets/images/contact/location.png",
            title: "Rwanda Office",
            text: [
                "006/45, Cyangugu,",
                "Kamembe, RUSIZI,",
                "RWANDA"
            ]
        },
        {
            imgSrc: "/assets/images/contact/location.png",
            title: "Uganda Office",
            text: [
                "Shop No. B1,",
                "Nakiyubo Road,",
                "Kampala, Uganda"
            ]
        },
        {
            imgSrc: "/assets/images/contact/call.png",
            title: "Mr. Anand Wankar",
            text: [
                "CEO",
                <Link to="tel:+971502146919" target="_blank" key="1">📞 +971 502 146 919</Link>,
                <Link to="tel:+917387683337" target="_blank" key="2">📞 +91 73876 83337</Link>,
                <Link to="mailto:anandwankar@ayanshinternational.com" target="_blank" key="3">✉️ anandwankar@ayanshinternational.com</Link>,
                <Link to="mailto:anandwankar88@gmail.com" target="_blank" key="4">✉️ anandwankar88@gmail.com</Link>
            ]
        },
        {
            imgSrc: "/assets/images/contact/call.png",
            title: "Mrs. Ananya Wankar",
            text: [
                "Co-CEO",
                <Link to="mailto:ananyawankar@ayanshinternational.com" target="_blank" key="5">✉️ ananyawankar@ayanshinternational.com</Link>
            ]
        },
        {
            imgSrc: "/assets/images/contact/call.png",
            title: "Mr. Salman Musani",
            text: [
                "Managing Director",
                <Link to="tel:+918983707790" target="_blank" key="6">📞 (+91) 89837 07790</Link>,
                <Link to="mailto:salmanmusani@ayanshinternational.com" target="_blank" key="7">✉️ salmanmusani@ayanshinternational.com</Link>,
                <Link to="mailto:salman.musani07@gmail.com" target="_blank" key="8">✉️ salman.musani07@gmail.com</Link>
            ]
        },
        {
            imgSrc: "/assets/images/contact/call.png",
            title: "Company Contact Details",
            text: [
                <Link to="https://www.ayanshinternational.com" target="_blank" key="9">🌐 www.ayanshinternational.com</Link>,
                <Link to="tel:+971502146919" target="_blank" key="10">📞 +971 502 146 919</Link>,
                <Link to="mailto:info@ayanshinternational.com" target="_blank" key="11">✉️ info@ayanshinternational.com</Link>,
                <Link to="mailto:sales@ayanshinternational.com" target="_blank" key="12">✉️ sales@ayanshinternational.com</Link>,
                <Link to="mailto:support@ayanshinternational.com" target="_blank" key="13">✉️ support@ayanshinternational.com</Link>
            ]
        }
    ];

    return (
        <section className='Contact_card'>
            <div className='contact_card_holder'>
                <div className="row justify-content-center">
                    {contactItems.map((item, index) => (
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-5" key={index}>
                            <div className="card_holder">
                                <div className="img_holder">
                                    <img className="logo_img"
                                        src={process.env.PUBLIC_URL + item.imgSrc}
                                        alt="logo" />
                                </div>
                                <div className='text_holder'>
                                    <h4>{item.title}</h4>
                                    {Array.isArray(item.text) ? (
                                        item.text.map((line, i) => (
                                            <p key={i}>{line}</p>
                                        ))
                                    ) : (
                                        <p>{item.text}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Contact_card;
